<template>
  <div>
    <app-cells><h1 class="title">Amendments requests</h1></app-cells>
    <app-tabs :tabs="tabs" />
    <transition name="fade" mode="out-in">
      <router-view  />
    </transition>
  </div>
</template>

<script>
import AppTabs from '@/components/AppTabs'

export default {
  name: 'HotelsAmendmentsLayout',
  components: { AppTabs },
  data() {
    return {
      tabs: [
        { name: 'reservation-hotels-amendments-pending', label: 'Pending' },
        { name: 'reservation-hotels-amendments-completed', label: 'Completed' },
        { name: 'reservation-hotels-amendments-stopped', label: 'Stopped' },
      ],
    }
  },
}
</script>
